module.exports = __webpack_public_path__ + "static/img/home_carousel_3.75226ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/home_carousel_3.png
// module id = fphI
// module chunks = 15